import React from 'react';
import './mobilelist.css';
import akash from '../../images/institute.png';
import { AiFillStar } from "react-icons/ai";
import { BsBookmark } from "react-icons/bs";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { baseUrl } from '../../context/BaseUrl';
import { toast, ToastContainer } from 'react-toastify';
import { useState } from 'react';


const MobList = (props) => {
    const [bkmrk, setBkmrk] = useState(false)
    const [voide, setVoide] = useState(false)
    const BookMarked = async (value) => {
        setBkmrk(true)
        // try {
        const val = localStorage.getItem("user");
    
        if (!val) {
          toast.error("You are not logged in.");
          return;
        }
    
        const user = JSON.parse(val);
        const id = user.user._id;
        const token = user.token;
    
        const data = {
          institute_id: value,
          user_id: id,
        };
    
        const response = await fetch(
          `${baseUrl}/user/user_rights/postfollow/${id}`,
          {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
          }
        );
        const result = await response.json();
        toast.success(result.msg, {
          position: toast.POSITION.TOP_LEFT,
        });
        setBkmrk(false)
      };
      const pathchanger = () => {
        if(bkmrk){
           setVoide(true) 
        }else{
            setVoide(false)
        }
      }

    return (
 
        <>
              <ToastContainer />

            <Link className='text-decoration-none text-black' onClick={pathchanger} to={voide ?  "" :  `/institute/${props.institute_id}`}>
            <div className="grid-card moblist ">
                <div className="logo d-flex">
                    <img src={props.image} alt='akash' />
                    <div className="center">
                        <h5 className='name'><Link to={`/institute/${props.institute_id}`}>{props.name}</Link></h5>
                        <p>Rating 4.2 <span className='num'>(1562)</span> </p>
                        <span><AiFillStar /> <AiFillStar /> <AiFillStar /> <AiFillStar /></span>
                    </div>
                    <h6 onClick={() => BookMarked(props.institute_id)}> <BsBookmark /></h6>
                </div>
                <p className='location'> <GoLocation /> {props.location} </p>

                <p className='p-abt'> {parse(props.about)} </p>
                <div className="buttons d-none">
                    {/* <button className='view'>View Courses</button> */}
                    <button className='more w-100'>
                        <Link to={`/institute/${props.institute_id}`}>Know More</Link>
                    </button>
                </div>
            </div>
            </Link>
        </>

    )
}

export default MobList